import { Skeleton } from '@mui/material'
import React from 'react'

const SkeletonTable = () => {
  return (
    <>
      <Skeleton height={100} sx={{ mt: -1 }} />
      {[...Array(15)].map((item, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          sx={{ mb: 1 }}
          height={30}
        />
      ))}
    </>
  )
}

export default SkeletonTable
